<style scoped>

.file-operate {
  width: 425px;
}

.operte-btns {
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
}

.operte-btns .btn {
  padding: 5px 18px;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  cursor: pointer;
  margin-right: 10px;
}

.operte-btns .btn.save {
  border: 1px solid rgba(79, 161, 164, 1);
  color: rgba(79, 161, 164, 1);
  cursor: pointer;
}

.operte-btns .btn.submit {
  border: 1px solid rgba(79, 161, 164, 1);
  background: rgba(79, 161, 164, 1);
  color: #fff;
  cursor: pointer;
}

.operte-btns .cancel {
  margin-left: 230px;
}

.conBox {
  display: flex;
  align-items: flex-start;
  width: 100%;
  padding: 6px;
  box-sizing: border-box;
  position: relative;
  overflow-y: scroll;
}

.conBox .navList {
  width: 140px;
  background: #fff;
  position: fixed;
  top: 93px;
}

.conBox .navList .title {
  height: 64px;
  line-height: 64px;
  font-size: 20px;
  border-bottom: 1px solid #f6f7fa;
}

.conBox .navList .cell {
  margin: 4px 10px;
  line-height: 32px;
  cursor: pointer;
}

.conBox .navList .active {
  background: #eaf7f7;
}

.conBox .conList {
  flex: 1;
  padding: 0 6px 36px 146px;
  box-sizing: border-box;
}

.conBox .conList .cellBox {
  background: #fff;
  margin-bottom: 8px;
  padding: 16px;
}

.conBox .conList .cellBox .title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f6f7fa;
  padding: 0 10px 16px 10px;
  margin-bottom: 16px;
}

.conBox .conList .cellBox .title .left {
  font-size: 20px;
}

.conList .cellBox .title .right span {
  background: #4fa1a4;
  color: #fff;
  padding: 6px 20px;
  display: inline-block;
  margin-left: 14px;
  cursor: pointer;
}

.conBox .userInfo {
  width: 300px;
  background: #fff;
}

/* 右侧公司信息 */
.carouselBox {
  padding: 16px;
  box-sizing: border-box;
}

.carouselBox .title {
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  justify-content: center;

  margin-bottom: 10px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f6f7fa;
}

.carouselBox .title .left {
  color: #323232;
  font-size: 20px;
  width: 100%;
}

.carouselBox .title .right {
  font-size: 14px;
  display: flex;
  align-items: center;
  color: #909399;
}

.carouselBox .title .right img {
  width: 18px;
  height: 18px;
}

.carouselBox .con {
  position: relative;
  color: #323232;
  font-size: 14px;
  padding-top: 30px;
  border-bottom: 1px solid #f6f7fa;
  padding-bottom: 16px;
  margin-bottom: 20px;
}

.carouselBox .con .userIcon {
  width: 96px;
  height: 96px;
  overflow: hidden;
  background: #f6f7fa;
  border-radius: 8px;
  margin: 0 auto;
  position: relative;
  cursor: pointer;
}

.carouselBox .con .userIcon:hover span {
  display: inline-block;
}

.carouselBox .con .userIcon span {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  line-height: 26px;
  color: #fff;
  background: rgba(0, 0, 0, 0.7);
  display: none;
}

.carouselBox .con .userIcon img {
  width: 100%;
}

.carouselBox .con .name {
  font-size: 30px;
  margin: 10px 0 4px 0;
}

.carouselBox .con .userType {
  position: absolute;
  left: 0;
  top: 0;
}

.carouselBox .con .userType p {
  display: flex;
  align-items: center;
  margin: 0;
}

.carouselBox .con .userType p img {
  width: 16px;
  height: 16px;
}

.carouselBox .con .userType .zhengshi {
  color: #4fa1a4;
}

.carouselBox .con .userType .shiyong {
  color: #e59940;
}

.bottom .line {
  display: flex;
  align-items: flex-start;
  padding: 10px 10px 0 20px;
}

.carouselBox .bottom .line img {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}

.carouselBox .bottom .line span {
  display: block;
  color: #323232;
  text-align: left;
  font-size: 14px;
}

.userInfo .opreate {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  color: #909399;
  position: absolute;
  bottom: 16px;
  width: 100%;
  padding: 0 16px;
  box-sizing: border-box;
}

.userInfo .opreate span {
  cursor: pointer;
}

.userInfo /deep/ .el-carousel__container {
  height: 520px;
  position: relative;
}

.userInfo /deep/ .el-carousel__arrow {
  display: none;
}

.userInfo /deep/ .el-carousel__indicators--horizontal {
  display: none;
}

.brokerInsuredDetail .content /deep/ .el-form-item {
  margin-bottom: 12px;
}

.conList .cardboxStyle {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-left: 5%;
  /* margin: 5px 80px; */
}

.conList .cardStyle {
  /* width: 363px; */
  width: 97%;
  /* height: 165px; */
  margin: 6px;
  margin-top: 0px;
  border: 1px solid #d9d9d9;
}

.title1 {
  display: flex;
  flex-direction: column;
}

/* .titleTo{
  margin-top: 20px;
} */
.sangeSpan {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  color: #666666;
  width: 320px;
  /* height: 63px; */
  margin: 15px 35px 17px 16px;
}

.sangeSpan .classNames {
  width: 300px;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 4px;
}

.sangeSpan .jianJu {
  margin-left: 8px;
}

.gongSi {
  text-align: left;
  font-size: 16px;
  font-weight: 700;
  margin: 12px 80px 12px 16px;
}

.active {
  background-color: #ebf6f7;
}

::v-deep
  .el-container
  .brokerInsuredDetail
  .content
  .el-form-item
  .is-required {
  margin-bottom: 8px;
}

::v-deep .el-collapse-item__header {
  padding-left: 10px;
  font-size: 16px;
}

::v-deep #forbiddenText .fieldItemClass .dialog-form {
  display: flex;
  flex-direction: column;
}

::v-deep #forbiddenText .fieldItemClass .el-form-item {
  display: flex;
  flex-direction: column;
}

::v-deep #forbiddenText .fieldItemClass .el-form-item__label {
  width: 100%;
  text-align: left;
  line-height: 22px;
  margin-left: 10%;
}

::v-deep #forbiddenText .fieldItemClass .dialog-form .el-col-12 {
  width: 100%;
}

.el-collapse-item__header {
  padding-left: 10px;
}

.right {
  z-index: 10;
  top: 5px;
  right: 25px;
  position: absolute;
}

.xiaoGezi {
  width: 20px;
  height: 10px;
  background-color: #fff;
}

::v-deep .content .el-form-item {
  margin-bottom: 8px !important;
}
.conBox .conList .cellBox {
  padding: 0px;
}
.el-collapse-item__header {
  height: 40px;
}
.el-input--small .el-input__inner {
  color: #212121;
}
.quxiaoButton{
  margin-right: 5px !important;
}
.collapseAtive .el-collapse-item{
  position: relative;
}
.collapseAtive  .el-collapse-item__arrow {
  position: absolute;
  top: 18px;
  right: 0px;
}
.el-collapse {
  position: relative;
}
</style>
<style>
#forbiddenText .fieldItemClass .el-form .el-form-item .el-form-item__content {
  margin-left: -11% !important;
}
</style>
<template>
  <div
    class="brokerInsuredDetail"
    v-loading.fullscreen.lock="fullscreenLoading"
  >
    <div class="conBox" :style="'height:' + conHeight + 'px;'">
      <div class="navList">
        <div class="title">人员详情</div>
        <div
          :class="currentGroup == index ? 'cell active' : 'cell'"
          v-for="(item, index) in allGroupData"
          :key="index"
          @click="handleLeft(index)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="conList">
        <!-- :id='m.sourceName==="背调结果信息"?"forbiddenText":""' -->
        <div
          v-for="(item, index) in allGroupData"
          :key="index"
          :id="'id' + index"
          class="cellBox"
        >
          <div class="title1">
            <el-collapse class="collapseAtive" v-model="activeNames">
              <span class="xiaoGezi"></span>
               <template v-if="!flowType">
                  <div class="right" v-if="index != 1">
                    <el-button
                      v-if="item.isEdit"
                      @click="item.isEdit = false"
                      size="small"
                      
                      >编辑</el-button
                    >
                    <el-button
                      v-if="!item.isEdit"
                      :loading="item.submitLoading"
                      @click="saveForm(item, index)"
                      size="small"
                    
                      >保存</el-button
                    >
                    <el-button
                      v-if="!item.isEdit"
                      :loading="item.submitLoading"
                      @click="cancelEdit(item, index)"
                      size="small"
                      class="quxiaoButton"
                      >取消</el-button
                    >
                  </div>
                  <div class="right" v-if="index == 1">
                    <el-button
                      v-if="item.isEdit"
                      @click="item.isEdit = false"
                      size="small"
                      
                      >编辑</el-button
                    >
                    <el-button
                      v-if="!item.isEdit"
                      :loading="item.submitLoading"
                      @click="saveForm(item, index)"
                      size="small"
                      
                      >保存</el-button
                    >
                    <el-button
                      v-if="!item.isEdit"
                      :loading="item.submitLoading"
                      @click="cancelEdit(item, index)"
                      size="small"
                      class="quxiaoButton"
                      >取消</el-button
                    >
                  </div>
                </template>
              <el-collapse-item :title="item.name" :name="index + 1">
                <template v-if="item.name == '备案信息'">
                  <div class="left">
                    <span> {{ item.formVisible }}</span>
                  </div>
                  <!-- <span style=" position: relative;top: 0px;left: -43%;color: #666666;"> 入职公司</span> -->
                  <div class="titleTo"></div>
                  <div class="cardboxStyle">
                    <div
                      v-for="(item, index) in tenantGuidArr"
                      :key="index"
                      
                    >
                    <!-- @click="dynamicDisplay(item)" -->
                      <div
                        class="cardStyle"
                        :class="[isActive == index ? 'active' : '']"
                        @click="styleChanges(index)"
                      >
                        <div class="gongSi">{{ item.companyName }}</div>
                        <div class="sangeSpan">
                          <el-popover
                            placement="top-start"
                            trigger="hover"
                            :content="`${
                              Array.isArray(item.organs)
                                ? item.organs.join('、')
                                : '-'
                            }`"
                          >
                            <div slot="reference">
                              <div class="classNames">
                                所在组织:
                                <span
                                  v-if="Array.isArray(item.organs) && item.organs.length"
                                >
                                  <span
                                    v-for="(item, index) in item.organs"
                                    :key="index"
                                  >
                                    <span class="jianJu">{{ item }}</span>
                                  </span>
                                </span>
                                <span class="jianJu" v-else>-</span>
                              </div>
                            </div>
                          </el-popover>
                          <el-popover
                            placement="top-start"
                            width="200"
                            trigger="hover"
                            :content="`${
                              Array.isArray(item.positionNames)
                                ? item.positionNames.join('、')
                                : '-'
                            }`"
                          >
                            <div slot="reference">
                              <div class="classNames">
                                所在岗位:
                                <span
                                  v-if="Array.isArray(item.positionNames) && item.positionNames.length"
                                >
                                  <span
                                    v-for="(item, index) in item.positionNames"
                                    :key="index"
                                  >
                                    <span class="jianJu">{{ item }}</span>
                                  </span>
                                </span>
                                <span class="jianJu" v-else>-</span>
                              </div>
                            </div>
                          </el-popover>
                          <el-popover
                            placement="top-start"
                            width="200"
                            trigger="hover"
                            :content="`${
                              Array.isArray(item.salesTerritory)
                                ? item.salesTerritory.join('、')
                                : '-'
                            }`"
                          >
                            <div slot="reference">
                              <div class="classNames">
                                销售区域:
                                <span
                                  v-if="Array.isArray(item.salesTerritory) && item.salesTerritory.length"
                                >
                                  <span
                                    v-for="(item, index) in item.salesTerritory"
                                    :key="index"
                                  >
                                    <span class="jianJu">{{ item }}</span>
                                  </span>
                                </span>
                                <span class="jianJu" v-else>-</span>
                              </div>
                            </div>
                          </el-popover>
                          <!-- <el-popover
                            placement="top-start"
                            width="200"
                            trigger="hover"
                            :content="`${
                              Array.isArray(item.salesTerritory)
                                ? item.salesTerritory.join('、')
                                : '-'
                            }`"
                          > -->
                            <div slot="reference">
                              <div class="classNames">
                                备案日期:
                                <span
                                  v-if=" item.createTime"
                                >
                                <span class="jianJu">{{ item.createTime | getDate }}</span>
                                  
                                </span>
                              </div>
                            </div>
                          <!-- </el-popover> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- ||item.name == "奖惩信息" ? "rewardAndPunishmentInformation" : "" -->
                <div
                  class="content"
                  :id="item.name == '背调结果信息' ? 'forbiddenText' : ''"
                >
                  <!-- <template v-if="!flowType">
                    <div class="right" v-if="index != 1">
                      <el-button
                        v-if="item.isEdit"
                        @click="item.isEdit = false"
                        size="small"
                        
                        >编辑</el-button
                      >
                      <el-button
                        v-if="!item.isEdit"
                        :loading="item.submitLoading"
                        @click="saveForm(item, index)"
                        size="small"
                      
                        >保存</el-button
                      >
                      <el-button
                        v-if="!item.isEdit"
                        :loading="item.submitLoading"
                        @click="cancelEdit(item, index)"
                        size="small"
                       
                        >取消</el-button
                      >
                    </div>
                    <div class="right" v-if="index == 1">
                      <el-button
                        v-if="item.isEdit"
                        @click="item.isEdit = false"
                        size="small"
                        type="info"
                        >编辑</el-button
                      >
                      <el-button
                        v-if="!item.isEdit"
                        :loading="item.submitLoading"
                        @click="saveForm(item, index)"
                        size="small"
                        type="info"
                        >保存</el-button
                      >
                      <el-button
                        v-if="!item.isEdit"
                        :loading="item.submitLoading"
                        @click="cancelEdit(item, index)"
                        size="small"
                        type="info"
                        >取消</el-button
                      >
                    </div>
                  </template> -->
                  <FieldItem
                    :guid="formData.guid"
                    :formColumn="item.tableData"
                    :ref="'fieldItem' + index"
                    :form="formData"
                    :isEdit="item.isEdit"
                    :otherFile="otherFile"
                    @updateIsEdit="updateIsEdit(item)"
                    @updateLading="updateLading(item)"
                    @dynamicModification="dynamicModification"
                    @dynamicModifications="dynamicModifications"
                  ></FieldItem>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>

          <template v-if="flowType">
            <div></div>
            <div class="operte-btns">
              <div class="btn cancel" @click="$router.go(-1)">取消</div>
              <div class="btn submit" @click="saveReq">提交申请</div>
            </div>
          </template>
        </div>
      </div>

      <!-- <div class="userInfo">
        <el-carousel :interval="5000" arrow="always" :autoplay="false" :loop="false" ref="carousel">
          <el-carousel-item v-for="(item, index) in companyInfo.staffDetail" :key="index">
            <div class="carouselBox">
              <div class="title">
                <span class="left">公司信息</span>
                <div class="right">
                  <img v-if="companyInfo.hasAccount == '0'" src="../../assets/icon/newIcon6.png" alt="">
                  <span v-if="companyInfo.hasAccount == '0'">账号未开通</span>
                  <img v-if="companyInfo.hasAccount == '1'" src="../../assets/icon/newIcon6.png" alt="">
                  <span v-if="companyInfo.hasAccount == '1'" style="color:#4fa1a4;">账号已开通</span>
                </div>
              </div>
              <div class="con">
                <div class="userType">
                  <p class="zhengshi" v-if="companyInfo.staffStatus == '1'"><img src="../../assets/icon/newIcon4.png"
                      alt=""><span>正式员工</span></p>
                  <p class="shiyong" v-if="companyInfo.staffStatus == '2'"><img src="../../assets/icon/newIcon5.png"
                      alt=""><span>试用员工</span></p>
                </div>
                <div class="userIcon">
                  <el-upload :ref="'uploadUserIcon' + index" class="avatar-uploader" action="#" :limit="1"
                    :show-file-list="false" :before-upload="beforeAvatarUpload"
                    :http-request="(file) => { return uploadImage(file, index) }">
                    <img :src="companyInfo.profile ? companyInfo.profile : require('../../assets/icon/userIcon.png')" alt="">
                    <span>编辑</span>
                  </el-upload>
                </div>
                <div class="name">{{ companyInfo.name }}</div>
                <div>{{ companyInfo.staffNo ? 'No.' + companyInfo.staffNo : '' }}</div>
              </div>
              <div class="bottom">
                <div class="line">
                  <img src="../../assets/icon/newIcon1.png" alt="">
                  <span>{{ item.companyName }}</span>
                </div>
                <template v-for="(m, mIndex) in item.organisations">
                  <div class="line" :key="mIndex + 1">
                    <img src="../../assets/icon/newIcon2.png" alt="">
                    <div style="text-align:left;"><span>{{ m ? m.join('-') : '' }}</span></div>
                  </div>
                </template>
                <div class="line" v-if="item.salesTerritory.length || item.positionNames">
                  <img src="../../assets/icon/newIcon3.png" alt="">
                  <div><span v-for="(t, tIndex) in item.salesTerritory" :key="tIndex + 1">{{ t + ' - ' }}</span> <span
                      v-for="(o, oIndex) in item.positionNames" :key="oIndex">{{ o }}</span></div>
                </div>
              </div>
            </div>
            <div class="opreate">
              <span v-if="index != 0" @click="prev(index - 1)">上一页</span>
              <span v-if="index + 1 != companyInfo.staffDetail.length" @click="next(index + 1)">下一页</span>
            </div>
          </el-carousel-item>

          <el-carousel-item v-if="companyInfo.staffDetail == null || companyInfo.staffDetail.length == 0">
            <div class="carouselBox">
              <div class="title">
                <span class="left">公司信息</span>
                <div class="right">
                  <img v-if="companyInfo.hasAccount == '0'" src="../../assets/icon/newIcon6.png" alt="">
                  <span v-if="companyInfo.hasAccount == '0'">账号未开通</span>
                  <span v-if="companyInfo.hasAccount == '1'" style="color:#4fa1a4;">账号已开通</span>
                </div>
              </div>
              <div class="con">
                <div class="userType">
                  <p class="zhengshi" v-if="companyInfo.staffStatus == '1'"><img src="../../assets/icon/newIcon4.png"
                      alt=""><span>正式员工</span></p>
                  <p class="shiyong" v-if="companyInfo.staffStatus == '2'"><img src="../../assets/icon/newIcon5.png"
                      alt=""><span>试用员工</span></p>
                </div>
                <div class="userIcon">
                  <el-upload :ref="'uploadUserIcon0'" class="avatar-uploader" action="#" :limit="1"
                    :show-file-list="false" :before-upload="beforeAvatarUpload"
                    :http-request="(file) => { return uploadImage(file, 0) }">
                    <img :src="companyInfo.profile ? companyInfo.profile : require('../../assets/icon/userIcon.png')" alt="">
                    <span>编辑</span>
                  </el-upload>
                </div>
                <div class="name">{{ companyInfo.name }}</div>
                <div>{{ companyInfo.staffNo ? 'No.' + companyInfo.staffNo : '' }}</div>
              </div>
            </div>
          </el-carousel-item>

        </el-carousel>
      </div> -->
    </div>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import FieldItem from './fieldItem.vue';
export default {
  data() {
    return {
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      conHeight: window.innerHeight - 85,
      currentGroup: 0,
      listBoxState: true, //处理导航
      allGroupData: [], //全部分组
      allFiledData: [], //全部字段
      formData: {},
      companyInfo: [], //公司信息
      timeId: null,
      flowType: null,
      fullscreenLoading: false,
      tenantGuidArr: [],
      otherFile: {}, //上传的数据,
      staffRecordTenantGuidArr: null,
      //颜色
      isActive: 0,
      indexs: 0,
      //个数
      activeNames: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      theValuePassedOver: {},
      pdeerArr: [],
      valueOver: '',
      gongsXianArr: [],
      fileField : [ // !附件字段
        "medicalReport",
        "dimissionReport",
        "contractFile",
        "idFrontPictContent",
        "idBackPictContent",
      ]
    };
  },
  components: {
    FieldItem,
  },
  created() {
    //dutyStatus 1在职 3离职
    this.formData = JSON.parse(this.$route.query.item);
    this.formData.promotionCategory = this.formData.promotionCategory
      ? this.formData.promotionCategory.split('、')
      : [];

    // this.getGroupList()
    if (this.$route.query.approvalState !== 'Y') {
      // 简历同步花名册不走审批流
      this.getUpdateApproval();
    }
    this.getluojiPromise();
  },
  mounted() {
    window.addEventListener('scroll', this.bodyScroll, true);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.bodyScroll, true);
  },
  wacth: {
    alueOver: {
      handler(newValue, oldValue) {
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    //样式变化
    styleChanges(index1) {
      this.isActive = index1;
    },

    //更新可编辑状态
    updateIsEdit(item) {
      item.isEdit = true;
      if (this.$route.query.cvInfoGuid) {
        this.syncRoster(this.$route.query.cvInfoGuid, 'Y', () => {
          this.$router.go(-1);
        });
      }
    },
    //更新保存加载状态
    updateLading(item) {
      item.submitLoading = !item.submitLoading;
    },
    //上传头像保存
    saveUserIcon(filePath, filename, index) {
      let data = {
        path: filePath,
        fileName: filename,
      };

      // rosterParam.promotionCategory = arr.join("、");
      let params = {
        tenantGuid: this.$store.state.guid,
        staffGuid: this.formData.guid,
        guid: this.formData.guid,
        // rosterParam: {
        //   profilePhoto: filePath,
        // },
        rosterParam: {
          profilePhoto: filePath,
          promotionCategory: arr.join('、'),
        },
      };
      this.api.put(`/${serverConfig.msPersonnelService}/staff-roster/save-or-update`, params).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.$message.success('上传成功 !');
          this.companyInfo.profile = filePath;
          let str = 'uploadUserIcon' + index;
          this.$refs[str][0].clearFiles();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //上传头像-执行上传
    uploadImage(file, index) {
      let formData = new FormData();
      formData.append('image', file.file);
      this.api
        .postImage(this.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.saveUserIcon(res.data.data, file.file.name, index);
          } else {
            this.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          this.$message('上传失败,请重新上传');
        });
    },
    //上传前校验
    beforeAvatarUpload(file) {
      let testmsg = file.name ? file.name.split('.')[1] : '';
      const isJPG = testmsg === 'jpeg' || testmsg === 'png' || testmsg === 'jpg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('文件格式不正确!');
      }
      if (!isLt2M) {
        this.$message.error('文件大小不能超过2MB!');
      }
      return isJPG && isLt2M;
    },
    //公司信息 上一页
    prev(i) {
      this.$refs.carousel.prev();
      this.initCompany(i);
    },
    //公司信息 下一页
    next(i) {
      this.$refs.carousel.next();
      this.initCompany(i);
    },
    //初始化公司
    initCompany(i) {
      if (!this.companyInfo.staffDetail) return;
      let staffDetail = this.companyInfo.staffDetail[i];
      if (!staffDetail) return;
      this.formData.joinAge = staffDetail.joinAge; //司龄
      this.formData.entryDate = staffDetail.entryDate; //入职时间
      this.formData.regularDate = staffDetail.regularDate; //转正时间
      this.formData.salary = staffDetail.salary; //当前工资
      this.formData.officialSalary = staffDetail.officialSalary; //转正工资
      this.formData.probationSalary = staffDetail.probationSalary; //试用期工资
      this.formData.probationPeriod = staffDetail.probationPeriod; //试用期
      this.formData.dutyStatus = staffDetail.dutyStatus; //在职状态
      this.formData.dimissionType = staffDetail.dimissionType; //离职类型
      this.formData.dimissionDate = staffDetail.dimissionDate; //离职时间
      this.formData.dimissionReport = staffDetail.dimissionReport; //离职报告
      this.formData.medicalReport = staffDetail.medicalReport; //体检报告
      this.formData.positionLevel = staffDetail.positionLevel; //职级
      this.formData.staffStatus = staffDetail.staffStatus; //状态
      this.formData.sendTenantGuid = staffDetail.tenantGuid;
      this.staffRecordTenantGuidArr = this.formData.sendTenantGuid;
    },
    
    // todo 获取人员公司及岗位信息
    getchebianPromise() {
      let self = this;
      return new Promise((resolve, reject) => {
        self.api
          .get(
            `/${serverConfig.msPersonnelService}/staff-roster/profile?staffGuid=${self.formData.guid}&userGuid=${self.formData.userGuid}`,
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.companyInfo = res.data.data;
              self.tenantGuidArr = res.data.data.staffDetail ? res.data.data.staffDetail : [];


              // self.initCompany(0);
              let str = self.companyInfo.profile ? JSON.parse(self.companyInfo.profile) : '';
              self.companyInfo.profile = str.path;
              //导出值
              resolve(self.tenantGuidArr);
            } else {
              self.$message.error(res.data.msg);
            }
          });
      });
    },
    // todo 获取侧边模块分组列表查询
    getkapianPromise() {
      return new Promise((resolve, reject) => {
        let params = {
          pageSize: 100,
          pageIndex: 1,
          groupName: '',
          tenantGuid: this.$store.state.guid,
        };
        this.api.get(`/${serverConfig.msConfigureService}/cfg/group/list`, params).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.allGroupData = res.data.data.records ? res.data.data.records : [];

            resolve(this.allGroupData);
            this.getFieldList();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    getluojiPromise() {
      let self = this;
      // [self.getchebianPromise(),self.getchebianPromise()]
      Promise.all([self.getchebianPromise(), self.getkapianPromise()]).then(([res1, res2]) => {
        if (res1.length == 0) {
          this.allGroupData = res2.filter((element) => element.name !== '备案信息'); // 删除
        } else {
          this.allGroupData = res2;
        }
      });
    },

    //保存
    saveForm(item, index) {
      this.$refs['fieldItem' + index][0].saveForm();
    },
    //取消
    cancelEdit(item, index) {
      // this.getDetail()
      this.formData = JSON.parse(this.$route.query.item);
      this.$refs['fieldItem' + index][0].clearValidate();
      item.isEdit = true;
    },
    //获取花名册详情
    getDetail() {
      this.api.get(`/${serverConfig.msPersonnelService}/staff-roster/detail/${this.formData.guid}`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.formData = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //获取分组列表
    getGroupList(type) {
      let params = {
        pageSize: 100,
        pageIndex: 1,
        groupName: '',
        tenantGuid: this.$store.state.guid,
      };
      this.api.get(`/${serverConfig.msConfigureService}/cfg/group/list`, params).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.allGroupData = res.data.data.records ? res.data.data.records : [];

          this.getFieldList();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //获取字段列表
    getFieldList() {
      let params = {
        pageSize: 500,
        pageIndex: 1,
        tenantGuid: this.$store.state.guid, // '3d3861e610cb40218d3ecf641147affd',
        chineseName: '',
        fieldType: '',
      };
      this.api.get(`/${serverConfig.msConfigureService}/cfg/field/list`, params).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.allFiledData = res.data.data.records ? res.data.data.records : [];
          this.allGroupData.forEach((item) => {
            let tableData = [];
            this.allFiledData.forEach((oneData) => {
              if (oneData.groupGuid == item.guid) {
                oneData.dataSource = oneData.dataSource ? JSON.parse(oneData.dataSource) : [];
                tableData.push(oneData);
              }
            });
            tableData.sort((a, b) => {
              return a.formOrderNum - b.formOrderNum;
            });
            this.$set(item, 'tableData', tableData);
            this.$set(item, 'isEdit', false);
            this.$set(item, 'submitLoading', false);
          });
          // ! 简历信息同步
          this.$nextTick(() => {
            if (this.$route.query.cvInfoGuid) this.getCvInfo(this.$route.query.cvInfoGuid);
          });
          // this.getDetail() //获取到表单字段后，再获取表单数据
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //点击公司的动态显示
    dynamicDisplay(items) {
      this.allGroupData.forEach((item) => {
        if (item.name === '入职信息') {
          this.formData.entryDate = items.entryDate;
          this.$set(this.formData, 'entryDate', items.entryDate);
          this.formData.staffStatus = items.staffStatus;
          this.$set(this.formData, 'staffStatus', items.staffStatus);
          this.formData.joinAge = items.joinAge;
          this.$set(this.formData, 'joinAge', items.joinAge);
          this.formData.regularDate = items.regularDate;
          this.$set(this.formData, 'regularDate', items.regularDate);
          this.formData.probationPeriod = items.probationPeriod;
          this.$set(this.formData, 'probationPeriod', items.probationPeriod);
          this.formData.salary = items.salary;
          this.$set(this.formData, 'salary', items.salary);
          this.formData.officialSalary = items.officialSalary;
          this.$set(this.formData, 'officialSalary', items.officialSalary);
          this.formData.probationSalary = items.probationSalary;
          this.$set(this.formData, 'probationSalary', items.probationSalary);
          this.formData.dimissionType = items.dimissionType;
          this.$set(this.formData, 'dimissionType', items.dimissionType);
          this.formData.dimissionDate = items.dimissionDate;
          this.$set(this.formData, 'dimissionDate', items.dimissionDate);
          this.formData.positionLevel = items.positionLevel;
          this.$set(this.formData, 'positionLevel', items.positionLevel);
        }
      });
      this.formData.dimissionReport = items.dimissionReport; //离职报告
      this.formData.medicalReport = items.medicalReport; //体检报告
      this.staffRecordTenantGuidArr = items.tenantGuid
    },
    //页面滚动监听
    bodyScroll() {
      clearTimeout(this.timeId);
      this.timeId = setTimeout(() => {
        this.scrollToTop();
      }, 100);
    },
    // 点击导航菜单，页面滚动到指定位置
    handleLeft(index) {
      this.currentGroup = index;
      this.$el.querySelector(`#id${index}`).scrollIntoView({
        behavior: 'smooth', // 平滑过渡
        block: 'start', // 上边框与视窗顶部平齐。默认值
      });
      this.listBoxState = false;
      let timeId;
      clearTimeout(timeId);
      timeId = setTimeout(() => {
        this.listBoxState = true;
      }, 200);
    },
    // 监听页面元素滚动，改变导航栏选中
    scrollToTop() {
      // 获取视窗高度
      var domHight = document.body.offsetHeight;
      // dom滚动位置
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if (this.listBoxState) {
        //作用是点击导航栏时，延迟这里执行。
        this.allGroupData.map((v, i) => {
          // 获取监听元素距离视窗顶部距离
          var offsetTop = document.getElementById(`id${i}`).offsetTop;
          // 获取监听元素本身高度
          var scrollHeight = document.getElementById(`id${i}`).scrollHeight;
          // 如果 dom滚动位置 >= 元素距离视窗距离 && dom滚动位置 <= 元素距离视窗距离+元素本身高度
          // 则表示页面已经滚动到可视区了。
          if (scrollTop >= offsetTop && scrollTop <= offsetTop + scrollHeight) {
            // 导航栏背景色选中
            this.currentGroup = i;
          }
        });
      }
    },
    //判断该变更是否走流程
    getUpdateApproval() {
      let req = {
        flowOperationType: 2,
        functionCode: 'HMCGL',
        tenantGuid: localStorage.guid,
      };
      this.api
        .get(`/${serverConfig.msConfigureService}/function-workflow/data/get-flow-template-guid`, req)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data) {
              this.flowType = res.data.data.flowType;
            }
            this.flowType = true;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    //提交新增流程
    saveReq(sendTenantGuid) {
      let list = [];
      let scrollIndex;
      console.log('saveReq',this.allGroupData);
      
      this.allGroupData.forEach((item, index) => {
        if(item.name != '备案信息'){
          this.$refs['fieldItem' + index][0].saveOneForm();
          list.push(this.$refs['fieldItem' + index][0].newForm);
        }
        
      });
      list.splice(0, 1);
      list.some((item, index) => {
        if (!item) {
          scrollIndex = index;
          return !item;
        }
      });
      if (scrollIndex != null) {
        this.handleLeft(scrollIndex);
        return;
      }

      if (this.formData.baseCenter ==='1' || this.formData.baseCenter ==='3') {
        if (!this.formData.levyCompany) {
          this.$message.error('您选了终端服务中心,需要填写代征公司,才能提交!');
          let index = this.allGroupData.findIndex(item=>item.name === '奖金账户')
          if (index !=null) this.handleLeft(index);
          return;
        }
      }

      let userInfo = JSON.parse(localStorage.userInfo);
      let arr = this.$refs.fieldItem0[0].newForm.promotionCategory.split('/');
      this.$refs.fieldItem0[0].newForm.promotionCategory = arr.join('、');
      let params = [
        {
          tenantGuid: this.$store.state.guid,
          rosterParam: this.fileHanlde(this.$refs.fieldItem0[0].newForm), // !附件字段处理
          staffGuid: userInfo.staffGuid,
          guid: this.formData.guid,
          actionType: 'save',
          funcCode: 'HMCGL',
          staffRecordTenantGuid: this.staffRecordTenantGuidArr,
        },
      ];
      this.fullscreenLoading = true;
      this.api
        .postJson(`/${serverConfig.msPersonnelService}/staff-roster/workflow/update-roster-approval`, params)
        .then((res) => {
          this.fullscreenLoading = false;

          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.success('流程提交成功！');
            if (this.$route.query.cvInfoGuid) {
              this.syncRoster(this.$route.query.cvInfoGuid, 'Y', () => {
                this.$router.go(-1);
              });
            } else {
              this.$router.go(-1);
            }
          } else {
            this.$message.error(res.data.msg ? res.data.msg.replace(/[^\u4e00-\u9fa5]/g,''): '');
          }
        });
    },
    // 附件字段处理
    fileHanlde(newForm) {
      let rosterParam = JSON.parse(JSON.stringify(newForm))
      for (const key in rosterParam) {
        if (rosterParam.hasOwnProperty.call(rosterParam, key)) {
          if (this.fileField.includes(key)) {
            if (rosterParam[key] && rosterParam[key] === '[]') {
              rosterParam[key] = null
            }
          }
          
        }
      }
      return rosterParam
    },
    dynamicModification(res) {
      let { item } = res
      if (item && item.fieldName === 'baseCenter') {
        // todo 所属中心联动逻辑
        this.theValuePassedOver = res;
      }

      let self = this;

      if (res.value == 1 || res.value == 3) {
        let foundObj = self.allGroupData.find((item) => {
          return item.name == '奖金账户';
        });
        self.pdeerArr = foundObj.tableData;
      }
    },
    dynamicModifications(res) {
      this.valueOver = res.value;
      if (this.valueOver == 1) {
        let terminalServicesCenterArr = [1, 2, 3, 4, 5, 6, 10];
        this.activeNames = terminalServicesCenterArr;
      } else if (this.valueOver == 2) {
        let dataAcquisitionCenterArr = [1, 2, 3, 4, 6, 7, 8, 9, 10];
        this.activeNames = dataAcquisitionCenterArr;
      } else if (this.valueOver == 3) {
        let marketArr = [1, 2, 3, 4, 5, 10];
        this.activeNames = marketArr;
      } else {
        this.activeNames = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
      }
    },
    // ! =========== 简历同步花名册操作
    // 更新简历状态是否同步花名册
    syncRoster(guid, isSyncRoster, callBack) {
      let param = {
        guid,
        isSyncRoster,
      };
      if (!param.guid) return;
      this.api.put(`/${serverConfig.msPersonnelService}/staff-resume/data/update`, param).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.$message.success('同步成功');
          if (callBack) callBack();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 通过简历guid取简历详情
    getCvInfo(guid) {
      let self = this;
      let query = {
        keyword: guid,
      };
      if (!query.keyword) return;
      self.api
        .postJson(`/${serverConfig.msPersonnelService}/staff-resume/data/get-detail?keyword=${query.keyword}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (!res.data.data) {
              this.$message.error('暂无简历信息');
              return;
            }
            let cvItem = res.data.data;
            this.syncCvInfo(cvItem); // 简历信息赋值
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    syncCvInfo(item) {
      let cvInfo = {
        name: item.name, // 姓名
        mobileNo: item.mobileNo, // 电话
        professional: item.professional, // 专业
        sex: item.sex, // 性别
        idCode: item.idCode, // 证件号码
        education: item.education, // 学历
        graduatedFrom: item.graduatedFrom, // 毕业学校
      };
      let cvInfoKeyList = Object.keys(cvInfo);
      cvInfoKeyList.forEach((key) => {
        this.$set(this.formData, key, cvInfo[key]);
      });
    },
  },
};
</script>
